import { render, staticRenderFns } from "./tab-across.vue?vue&type=template&id=51f517d2&scoped=true"
import script from "./tab-across.vue?vue&type=script&lang=js"
export * from "./tab-across.vue?vue&type=script&lang=js"
import style0 from "./tab-across.vue?vue&type=style&index=0&id=51f517d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f517d2",
  null
  
)

export default component.exports